import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const HrRound = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.HR_ROUND} />
}

export default HrRound;